import { Link } from 'react-router-dom';
import { heroContent } from '@/mocks/home';

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[620px] md:min-h-[700px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Modern%20abstract%20gradient%20background%20with%20warm%20orange%20and%20soft%20cream%20tones%2C%20fluid%20organic%20shapes%2C%20minimalist%20geometric%20patterns%2C%20clean%20contemporary%20design%2C%20subtle%20texture%2C%20high%20quality%20editorial%20style%2C%20bright%20and%20airy%20atmosphere&width=1800&height=900&seq=hero-bg-main&orientation=landscape"
          alt="导航页在线发布平台"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/25 to-black/45"></div>
      </div>

      <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 text-center pt-16">
        <span className="inline-block px-4 py-1.5 rounded-full bg-white/15 backdrop-blur-sm text-background-50 text-sm font-medium mb-6 border border-white/20">
          {heroContent.badge}
        </span>

        <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-background-50 leading-tight mb-6 whitespace-pre-line">
          {heroContent.title}
        </h1>

        <p className="text-base md:text-lg text-background-50/80 max-w-2xl mx-auto mb-8 leading-relaxed">
          {heroContent.subtitle}
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-3 mb-14">
          <Link
            to={heroContent.primaryCtaHref}
            className="px-8 py-3.5 bg-primary-500 hover:bg-primary-600 text-background-50 font-semibold rounded-lg text-base transition-colors whitespace-nowrap cursor-pointer"
          >
            {heroContent.primaryCta}
          </Link>
          <Link
            to={heroContent.secondaryCtaHref}
            className="px-8 py-3.5 bg-white/10 hover:bg-white/20 backdrop-blur-sm text-background-50 font-medium rounded-lg text-base transition-colors whitespace-nowrap border border-white/20 cursor-pointer"
          >
            {heroContent.secondaryCta}
          </Link>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-8 max-w-3xl mx-auto">
          {heroContent.stats.map((stat) => (
            <div key={stat.label} className="text-center">
              <div className="text-2xl md:text-3xl font-bold text-background-50 mb-1">
                {stat.value}
              </div>
              <div className="text-xs md:text-sm text-background-50/60">
                {stat.label}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}